// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2wh0d","choiceBoxes":"toolbarselects_choiceBoxes__PUgav","simpleField":"toolbarselects_simpleField__1Ts8g"};